function TableBody({ children, className, header }) {
  return (
    <div className="">
      <div className="min-w-full">
        <div
          className={
            "grid gap-4 text-[#627491] text-sm mb-4 mx-7" + " " + className
          }
        >
          {header}
        </div>

        {children}
      </div>
    </div>
  );
}

export default TableBody;
